import type { DeviationCategory } from '@/types';

const getDeviationCategory = (deviation: number, willStart?: boolean): DeviationCategory => {
  if (willStart) {
    return 'early';
  }

  const deviationInMinutes = Math.round(deviation / 60);

  if (deviationInMinutes < 0) {
    return 'early';
  }

  if (deviationInMinutes < 3) {
    return 'onTime';
  }

  if (deviationInMinutes < 5) {
    return 'delayed';
  }

  return 'tooLate';
};

export default getDeviationCategory;
